import 'primereact/components/common/Common.css';
import 'primereact/components/button/Button.css';
import 'primereact/components/selectbutton/SelectButton.css';

import cssGlobal from '../../../utils/cssGlobal';
import constants from '../../../constants/styles';

const {
  HIGHLIGHT_COLOR,
  SELECT_ITEM_TEXT_COLOR,
  SELECT_ITEM_BORDER_COLOR
} = constants;

export default cssGlobal({
  '.ui-selectbutton .ui-button': {
    ':first-child': {
      borderRadius: '4px 0 0 4px'
    },
    ':last-child': {
      borderRadius: '0 4px 4px 0'
    }
  },
  '.ui-selectbutton .ui-button.ui-state-active': {
    border: `1px solid ${SELECT_ITEM_BORDER_COLOR}`,
    backgroundColor: HIGHLIGHT_COLOR,
    color: SELECT_ITEM_TEXT_COLOR
  }
});



// WEBPACK FOOTER //
// ./src/components/inputs/selectbutton/SelectButton.styles.js